import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// GLobal Components
import RoleTable from 'components/RoleTable';
import { ADMIN } from 'components/RoleGate/constants';
// @ts-ignore
import NoSearchResults from 'components/NoSearchResults';
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';

// Child Components
// @ts-ignore
import PeopleTableHead from './components/PeopleTableHead';
import PeopleTableRow from './components/PeopleTableRow';

// Selectors
// @ts-ignore
import { selectIds } from './selectors';

interface ConnectedProps {
    ids?: number[];
}

type Props = ConnectedProps;

export class PeopleTable extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { ids } = this.props;

        if (!ids || !ids.length) {
            return <NoSearchResults />;
        }

        return (
            <ResponsiveTable>
                <RoleTable requiredRoles={[ADMIN]}>
                    <PeopleTableHead ids={ids} />
                    <Table.Body>
                        {ids.map((id) => (
                            <PeopleTableRow key={id} personId={id} />
                        ))}
                    </Table.Body>
                </RoleTable>
            </ResponsiveTable>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    ids: selectIds
});

export default connect(mapStateToProps)(PeopleTable);
